<mat-toolbar [ngStyle]="{
	'background-color': jio_logo ? '#0057a7' : (currentUserData.utility?.name == 'KSEB' ? 'white' : 'rgb(86, 13, 13)'),
	'color': currentUserData.utility?.name == 'KSEB' ? 'black' : 'white'
  }"  class="example-toolbar nav-header">
    <div>
		<button mat-icon-button *ngIf="!ismobileView" (click)="isExpanded = !isExpanded;resizeChart()">
			<mat-icon>menu</mat-icon>
		</button>
		<button mat-icon-button *ngIf="ismobileView" (click)="sidenav.toggle();resizeChart()">
			<mat-icon>menu</mat-icon>
		</button>
	</div>
	
	<div *ngIf="!jio_logo || !solvey_logo || !raymond_logo">

	<div *ngIf="ismobileView">
		<img class="img-fluid" style="height: 6vh; width: 4vh;" alt="Theme-Logo" id="logo1" src="assets/images/AIP.png">
	</div>
	</div>

	

	<div >
		<img *ngIf="!ismobileView" style="height: 38px; width: 50px;" class="img-fluid" alt="Theme-Logo" id="logo1" src="assets/images/AIP.png">
	</div>
	
		<div style="margin-left: 6%;" *ngIf="currentUserData.dashboard == 4"><button (click)="selectedDashboard('dashboard')" class="btn btn-primary">TRANSFORMER DASHBOARD</button>&nbsp;&nbsp;<button (click)="selectedDashboard('pumpDashboard')" class="btn btn-info">PUMP DASHBOARD</button></div>

		<!-- <div *ngIf="ismobileView">
				<span style="padding-left: 4px;
				font-size: 14px; display: block; margin-bottom: 0em; 
				color: #EC2026;">BETTER OPERATIONS &</span>
				<span style="padding-left: 4px;
				font-size: 14px; display: block; margin-top: 0em; 
				color: #EC2026;">LIFE BY ANALYTICS</span>
		</div>
		<div *ngIf="!ismobileView">
				<span style="padding-left: 4px;
				font-size: 14px; display: block; margin-bottom: 0em; 
				color: #EC2026;">BETTER OPERATIONS & LIFE BY ANALYTICS</span>
		</div> -->

		<!-- <span style="padding-left: 4px;
		font-size: 10px; display: block; margin-bottom: -.2em; 
		color: #EC2026;"><p>BETTER OPERATIONS &<br style="display: block; margin-bottom: -.2em;">LIFE BY ANALYTICS </p></span>
		 -->
	
	<!-- <h1 class="example-app-name">BOLA</h1> -->
	<!-- <span *ngIf="ismobileView" style="flex: 0.7 0.7 auto;"></span>
	<span *ngIf="!ismobileView" style="flex: 1 1 auto;"></span> -->
	
	<span style="flex: 1 1 auto;"></span>	
	<div *ngIf="currentUserData.userid == 272">
		<img style="padding: 5px;" *ngIf="!ismobileView" class="img-fluid" alt="Theme-Logo" id="logo1" src="assets/images/indiapowerlogo.PNG">
	</div>
	
	<!-- <button type="button" class="btn launch" data-toggle="modal" data-target="#staticBackdrop"> <p class="mousehover" matBadge={{notificationCount}} matBadgeColor="warn" >
		<i style="font-size:24px" class="fa fa-bell"></i></p>
	</button>
	<div class="blob"></div>
	<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-body">
					<div class="text-right"> <i class="fa fa-close close" data-dismiss="modal"></i> </div><br>
					<div class="col-md-12" (click)="$event.stopPropagation();">
						<div class="row">
							<div class="col-md-6" *ngFor="let mandatory of mandatoryParameter" style="padding-bottom: 0px;"
								[style.color]="mandatory.color">
								<p (click)="$event.stopPropagation()"><b>{{mandatory.name}}</b></p>
								<p class="mousehover "><a [routerLink]=""
										(click)="$event.stopPropagation();showTable(mandatory)">{{mandatory.value}}</a></p>
							</div>
						</div>
						<hr (click)="$event.stopPropagation();">
					</div>
					<div class="col-md-12" (click)="$event.stopPropagation();">
						<div class="row">
							<div class="col-md-6" *ngFor="let nonmandatory of nonmandatoryParameter">
								<p style="width:95%">
									<span style="width:85%">{{nonmandatory.name}}</span>
									<span style="width:10%;float: right;">
										<mat-checkbox [(ngModel)]="nonmandatory.mandatory" (change)="checkboxChange(nonmandatory)"
											(click)="$event.stopPropagation();"></mat-checkbox>
									</span>
								</p>
							</div>
						</div>
					</div>
					<br>
					<div    *ngIf="displayname" style="width: 100%;overflow-y: scroll " (click)="$event.stopPropagation();">
						<table style="width: 100%;  "class="  table-bordered " >
							<thead class="name">
								<tr>
									<th *ngFor="let header of tableHeader; let i = index">{{header}}</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let data of tableBody">
									<td>{{data?.transformerid}}</td>
									<td>{{data?.alertType}}</td>
									<td>{{data?.maxtimestamp}}</td>
									<td>{{data?.value}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
-->
	
			<!-- <mat-icon class="mousehover" matBadge={{notificationCount}} matBadgeColor="warn" [matMenuTriggerFor]="menu1">
					notifications</mat-icon> -->

					<!-- <div *ngIf="isSwitchGearDashboard" style="padding-right: 10%;">
						<button mat-raised-button color="primary" [ngClass]="{'active-button': selectedButton === 'POWER', 'inactive-button': selectedButton && selectedButton !== 'POWER'}" style="margin: 2%;" (click)="onSelect('POWER')" >
							POWER
						</button>
						<button mat-raised-button color="primary" [ngClass]="{'active-button': selectedButton === 'DISTRIBUTION', 'inactive-button': selectedButton && selectedButton !== 'DISTRIBUTION'}" style="margin: 2%;" (click)="onSelect('DISTRIBUTION')">
							DISTRIBUTION
						</button>
						<button mat-raised-button color="primary" [ngClass]="{'active-button': selectedButton === 'SWITCHGEAR', 'inactive-button': selectedButton && selectedButton !== 'SWITCHGEAR'}" style="margin: 2%;" (click)="onSelect('SWITCHGEAR')">
							SWITCHGEAR
						</button>
						<button mat-raised-button color="primary" [ngClass]="{'active-button': selectedButton === 'LTP', 'inactive-button': selectedButton && selectedButton !== 'LTP'}" style="margin: 2%;" (click)="onSelect('LTP')">
							LTP
						</button>
						<button mat-raised-button color="primary" [ngClass]="{'active-button': selectedButton === 'FEEDER', 'inactive-button': selectedButton && selectedButton !== 'FEEDER'}" style="margin: 2%;" (click)="onSelect('FEEDER')">
							FEEDER
						</button>
					</div> -->


		<button mat-button [matMenuTriggerFor]="menu" style="text-transform: capitalize;">
			<i class="fa fa-user-circle fa-2x" aria-hidden="true"></i> {{currentUserData?.name}}</button>
		<mat-menu #menu="matMenu">
			<span *ngIf="currentUserData?.utility" style="padding: 1px;">{{currentUserData?.utility?.name}}</span><hr>
			<button mat-menu-item type="button" (click)="logout()"><i class="fa fa-th-large" aria-hidden="true"></i>
				&nbsp;Logout</button>
		</mat-menu>
		
		<div style="padding-top: 0px;font-size: 1.5vh">
				<p style="height: 10px;margin-top: 0px !important;">{{ now | date:'dd/MM/yyyy'}}</p>
				<p>{{ now | date:'HH:mm:ss'}}</p>
			</div>
</mat-toolbar>
<mat-sidenav-container   class="example-container" autosize>
	<mat-sidenav #sidenav class="example-sidenav" [mode]="isLargeScreen() ? 'side' : 'over'" opened="true"
	[style.background-color]="currentUserData.utility?.name == 'KSEB' ? 'white' : 'rgb(86, 13, 13)'"  *ngIf="!hideSideMenu">
	<mat-nav-list *ngFor="let item of dashboardArray;let i=index">
			<mat-list-item (click)="menuClick(i)" class="parent">
				<span *ngIf="item.haschildMenu" id="sidenavfont" style="display: flex;align-items: center"
					(click)="handleMenuClose()">
					<i [ngClass]="item.icon" [style.color]="currentUserData.utility?.name == 'KSEB' ? 'black' : 'white'" ></i>
					<span class="full-width bg-color" *ngIf="isExpanded">&nbsp;<b [style.color]="currentUserData.utility?.name == 'KSEB' ? 'black' : 'white'">{{item.name}}</b></span>
					<mat-icon class="menu-button" [ngClass]="{'rotated' : item.showSubmenu}" *ngIf="isExpanded">
						expand_more</mat-icon>
				</span>
				<span *ngIf="!item.haschildMenu" id="sidenavfont" style="display: flex;align-items: center">
					<i [ngClass]="item.icon" [style.color]="currentUserData.utility?.name == 'KSEB' ? 'black' : 'white'" (click)="isExpanded = !isExpanded;resizeChart()"></i>
					<a class="full-width bg-color" *ngIf="isExpanded"  (click)="setroute(item);handleMenuClose()"
						[routerLink]="item.link">&nbsp;<b [style.color]="currentUserData.utility?.name == 'KSEB' ? 'black' : 'white'">{{item.name}}</b></a>
				</span>
			</mat-list-item>
			<div class="submenu" [ngClass]="{'expanded' : item.showSubmenu}" *ngIf="item.showSubmenu && isExpanded">
				<div *ngFor="let childItem of item.childmenu">
					<a mat-list-item (click)="setroute(childItem)"[style.color]="currentUserData.utility?.name == 'KSEB' ? 'black' : 'white'" [routerLink]="childItem.link" (click)="handleMenuClose()"
						id="sidenavfont">{{childItem.name}}</a>
				</div>
			</div>
		</mat-nav-list>
	</mat-sidenav>
	<div style="padding: 10px;background-color: #F1F1F1;">
		<router-outlet></router-outlet>
	</div>


</mat-sidenav-container>